export function isCypress(): boolean {
  return Boolean((window as any).Cypress)
}
